// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminBookingTool.css */

.admin-booking-page {
    min-height: 100vh;
    background-color: #f5f7fa;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    /* margin: 1rem; */
    border: 3px solid var(--clr-primary-3);
  }
  
  /* Fade-in animation on load */
  @keyframes fadeInSlide {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .admin-booking-wrapper {
    width: 85%;
    background-color: #ffffff;
    padding: 32px;
    border-radius: 10px;
    border: 2px solid #ddd;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    animation: fadeInSlide 0.4s ease-in-out;
    transition: box-shadow 0.2s ease;
  }
  
  .admin-booking-wrapper:hover {
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
  }
  
  /* Auto spacing between child blocks */
  .admin-booking-wrapper > *:not(:last-child) {
    margin-bottom: 20px;
  }
  
  /* Enhanced heading */
  .admin-booking-wrapper h2 {
    margin-bottom: 10px;
    color: #2c3e50;
    font-size: 1.8rem;
    font-weight: 600;
    position: relative;
  }
  
  .admin-booking-wrapper p {
    margin-bottom: 24px;
    color: #555;
  }
  
  .proceed-button {
    background-color: #2ecc71;
    color: white;
    padding: 10px 18px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 20px;
    transition: background-color 0.2s ease;
    align-self: flex-start;
  }
  
  .proceed-button:hover {
    background-color: #27ae60;
  }
  
  .prac-status {
    margin-top: 10px;
    padding: 8px 12px;
    border-left: 4px solid #3498db;
    background-color: #f0f8ff;
    border-radius: 6px;
    font-size: 0.95rem;
    color: #333;
    font-weight: 500;
    display: inline-block;
  }
  
  /* Responsive styles */
  @media screen and (max-width: 768px) {
    .admin-booking-wrapper {
      width: 100%;
      padding: 2px;
    }
  
    .proceed-button {
      width: 100%;
      text-align: center;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/AdminBookingTool.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA,8BAA8B;EAC9B;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA,sCAAsC;EACtC;IACE,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,sBAAsB;EACtB;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;EACF","sourcesContent":["/* AdminBookingTool.css */\n\n.admin-booking-page {\n    min-height: 100vh;\n    background-color: #f5f7fa;\n    padding: 40px 20px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    /* margin: 1rem; */\n    border: 3px solid var(--clr-primary-3);\n  }\n  \n  /* Fade-in animation on load */\n  @keyframes fadeInSlide {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .admin-booking-wrapper {\n    width: 85%;\n    background-color: #ffffff;\n    padding: 32px;\n    border-radius: 10px;\n    border: 2px solid #ddd;\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    animation: fadeInSlide 0.4s ease-in-out;\n    transition: box-shadow 0.2s ease;\n  }\n  \n  .admin-booking-wrapper:hover {\n    box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);\n  }\n  \n  /* Auto spacing between child blocks */\n  .admin-booking-wrapper > *:not(:last-child) {\n    margin-bottom: 20px;\n  }\n  \n  /* Enhanced heading */\n  .admin-booking-wrapper h2 {\n    margin-bottom: 10px;\n    color: #2c3e50;\n    font-size: 1.8rem;\n    font-weight: 600;\n    position: relative;\n  }\n  \n  .admin-booking-wrapper p {\n    margin-bottom: 24px;\n    color: #555;\n  }\n  \n  .proceed-button {\n    background-color: #2ecc71;\n    color: white;\n    padding: 10px 18px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: background-color 0.2s ease;\n    align-self: flex-start;\n  }\n  \n  .proceed-button:hover {\n    background-color: #27ae60;\n  }\n  \n  .prac-status {\n    margin-top: 10px;\n    padding: 8px 12px;\n    border-left: 4px solid #3498db;\n    background-color: #f0f8ff;\n    border-radius: 6px;\n    font-size: 0.95rem;\n    color: #333;\n    font-weight: 500;\n    display: inline-block;\n  }\n  \n  /* Responsive styles */\n  @media screen and (max-width: 768px) {\n    .admin-booking-wrapper {\n      width: 100%;\n      padding: 2px;\n    }\n  \n    .proceed-button {\n      width: 100%;\n      text-align: center;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
